define(["require", "exports", "./string-structure.class", "./number-structure.class", "./array-structure.class", "./object-structure.class", "./structure.class", "./date-structure.class"], function (require, exports, string_structure_class_1, number_structure_class_1, array_structure_class_1, object_structure_class_1, structure_class_1, date_structure_class_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Structures = /** @class */ (function () {
        function Structures() {
        }
        Structures.string = function (defaultValue) {
            if (defaultValue === void 0) { defaultValue = ""; }
            return new string_structure_class_1.StringStructure(function (val) {
                return (typeof val) === "string";
            }, defaultValue);
        };
        Structures.date = function (timestamp) {
            if (timestamp === void 0) { timestamp = null; }
            return new date_structure_class_1.DateStructure(function (val) {
                return (typeof val) === "number";
            }, timestamp);
        };
        Structures.number = function (defaultValue) {
            if (defaultValue === void 0) { defaultValue = 0; }
            return new number_structure_class_1.NumberStructure(function (val) {
                return (typeof val) === "number";
            }, defaultValue);
        };
        Structures.array = function (defaultValue, length) {
            if (defaultValue === void 0) { defaultValue = []; }
            if (length === void 0) { length = 1; }
            return new array_structure_class_1.ArrayStructure(function (val) {
                return Array.isArray(val);
            }, defaultValue, length);
        };
        Structures.object = function (defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            return new object_structure_class_1.ObjectStructure(function (val) {
                return (typeof val) === "object" && !Array.isArray(val);
            }, defaultValue);
        };
        Structures.boolean = function (defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            return new structure_class_1.Structure(function (val) {
                return (typeof val) === "boolean";
            }, defaultValue);
        };
        Structures.custom = function (func) {
            return new structure_class_1.Structure(function (val) {
                return func(val);
            }, null);
        };
        return Structures;
    }());
    exports.Structures = Structures;
});
